import React, {useState} from "react";
import {Tab, Tabs} from "react-bootstrap";
import Upload from "./AddSlidePopup/Upload";
import Text from "./AddSlidePopup/Text";
import {ImageListType} from "react-images-uploading/dist/typings";

interface AddSlidePopupProps {
    onUpload: (imageList: ImageListType) => void,
    onAddText: (text: string) => void
}

const AddSlidePopup: React.FC<AddSlidePopupProps> = ({
                                                         onUpload,
                                                         onAddText
                                                     }) => {

    const [tabsKey, setTabsKey] = useState<any | null>('upload');

    return (
        <div className={'add-slides-popup'}>
            <Tabs
                activeKey={tabsKey}
                onSelect={(k) => {
                    setTabsKey(k);
                }}
            >
                <Tab title={'Загрузить фото'} eventKey={'upload'} tabClassName={'tab-item tab-photo'}>
                    <Upload onUpload={onUpload}></Upload>
                </Tab>
                <Tab title={'Добавить текст'} eventKey={'text'} tabClassName={'tab-item tab-text'}>
                    <Text
                        initialText={''}
                        isVisible={tabsKey == 'text'}
                        onAddText={onAddText}
                    ></Text>
                </Tab>
            </Tabs>
        </div>
    )
}

export default AddSlidePopup;